export const requestState = {
  CREATED: 'CREATED',
  DELETED: 'DELETED',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  NONE: 'NONE',
  ERROR: 'ERROR',
  UPDATED: 'UPDATED',
}
